import { mutations } from "User/store/mutations";
import ApiRequest from "Api/request";

const loginPage = "/Identity/Account/SignIn";
const request = new ApiRequest();

const actions = {
	async logInUser({ commit }, payload) {
		return await request.getToken(payload).then((result) => {
			if (result.success) {
				commit(mutations.LOG_USER_IN.name,
					{
						userName: result.userName,
						userLogged: result.success
					});
				return result;
			} else {
				return result;
			}
		});
	},
	logOutUser({ commit }) {
		commit(mutations.LOG_USER_OUT.name);

		request.logOut();
		location.href = loginPage;
	},
	async getUserInfo({ commit }) {
		await request.getUserInfo()
			.then((user) => {
				if (user.userName != null && user.userLogged) {
					commit(mutations.LOG_USER_IN.name, user);
				}
			});
	},
	async registerUser({ commit }, formData) {
		return await request.sendRegistrationData(formData)
			.then((result) => {
				return result;
			});
	}
};
export { actions };